import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
export const OPEN_MANAGE_RECORD_ACCESS_PANEL_HANDLER = {
  topic: TOPIC_NAMES.OPEN_MANAGE_RECORD_ACCESS_PANEL,
  type: 'MODAL',
  componentLoader: () => import('../wrappers/OpenManageRecordAccessPanel')
};